<template>
  <div style="width: 100%" class="pa-2">
    <div class="btn-group justify-between align-center">
      <span class="ml-2">Thư mục</span>
      <v-spacer></v-spacer>
      <v-btn icon small tile color="error" @click.stop="deleteFolder(item.id)">
        <v-icon>mdi-delete-outline</v-icon>
      </v-btn>
    </div>
    <v-divider class="mx-1"></v-divider>
    <div class="d-flex justify-start" @click="goFolder(item.id)">
      <v-avatar color="#F4F7FA" size="80" class="mt-3">
        <v-icon color="#073430" size="50">mdi-folder-open</v-icon>
      </v-avatar>
      <div class="pl-6 pt-3">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="text-truncate"
              style="font-size: 16px"
              >{{
                item.name && item.name.length > 30
                  ? item.name.substring(0, 30) + '...'
                  : item.name
              }}</div
            >
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
        <div class="pt-1 d-flex">
          {{ item.itemInfo.totalItemCount }}
          <span class="mr-1"></span>
          <span v-if="item.itemInfo.totalItemCount >= 2">items</span>
          <span v-else>item</span> <span class="mr-2 ml-2"> | </span>
          {{ getFileSize(item.itemInfo.size) }}</div
        >
        <div class="d-flex pt-2">
          <div class="btn-group">
            <base-button
              small
              :bindIcon="{ small: true }"
              @click.stop="editFolder(item)"
              type-action="update"
              no-icon
              color="#00ED64"
            >
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({
    dataSize: {},
  }),
  computed: {
    item() {
      return this.value
    },
  },
  mounted() {
    // this.value = { ...this.value, ...this.getFolderInfo(this.value.id) }
  },
  methods: {
    goFolder(id) {
      this.$emit('go-folder', id)
    },
    deleteFolder(id) {
      this.$emit('delete-folder', id)
    },
    editFolder(item) {
      this.$emit('edit-folder', item)
    },
    getFileSize(size) {
      try {
        let sizeKb = size / 1024
        if (sizeKb < 1024) {
          return sizeKb.toFixed(1) + ' Kb'
        } else {
          return (sizeKb / 1024).toFixed(1) + ' Mb'
        }
      } catch (error) {
        return ''
      }
    },
  },
}
</script>

<style></style>
